
import { defineComponent } from 'vue';
import Alert from '@/components/alerts/Alert.vue';

export default defineComponent({
  name: 'sign-up',
  components: {
    Alert,
  },
  computed: {
    hasRef() {
      return this.$route.query.ref;
    },
  },
  methods: {
    signIn() {
      this.$router.replace({
        name: 'sign-in',
        query: { req: this.$route.query.ref },
      });
    },
    signUp() {
      this.$router.replace({ name: 'sign-up' });
    },
  },
});
